// Tekster for pipeline pakke 3 (Tapt og gjenåpning). Egen fil så delene av
// pakken kan bygges hver for seg. Her: Gjenåpne og 6-ukersregelen, Revisit-
// fanen, tapsårsaker og konkurrenter i Innstillinger, og samtykke på kontakter.
export const norwegianPipelineReopenMessages = {
  crm: {
    deals: {
      status: {
        tab_revisit: "Revisit",
      },
      reopen: {
        reason: "Hvorfor gjenåpner vi?",
        reasons: {
          closed_too_early: "Avsluttet for tidlig",
          wrong_registration: "Feil registrering",
          customer_changed_mind: "Kunden ombestemte seg",
        },
        need_reason: "Velg en årsak.",
        lost_note:
          "Tapsårsak og revisit fjernes. De ligger fortsatt i historikken.",
        won_note:
          "Prosjekter og abonnementer som ble opprettet ved salget, endres ikke.",
        advice_title: "Gjenåpne eller ny mulighet?",
        lost_ago: "Tapt for %{time} siden (%{reason}).",
        lost_ago_no_reason: "Tapt for %{time} siden.",
        same_need: "Gjelder det samme behov og omtrent samme omfang?",
        yes: "Ja",
        no: "Nei",
        recommend_new: "Vi anbefaler ny mulighet.",
        recommend_reopen: "Vi anbefaler å gjenåpne («Avsluttet for tidlig»).",
        reopen_anyway: "Gjenåpne likevel",
        new_anyway: "Ny mulighet likevel",
        new_deal: "Ny mulighet",
        new_title: "Ny mulighet fra tapt",
        new_description:
          "Den nye muligheten havner i %{stage}, merkes som tilbakevendende og lenkes til den tapte. Den tapte beholder utfallet sitt.",
        create_new: "Opprett ny mulighet",
        new_created: "Ny mulighet er opprettet for %{name}",
        back: "Tilbake",
      },
      revisit: {
        ago: {
          days: "%{smart_count} dag |||| %{smart_count} dager",
          weeks: "%{smart_count} uke |||| %{smart_count} uker",
          months: "%{smart_count} mnd",
        },
        groups: {
          overdue: "Forfalt",
          this_week: "Denne uken",
          next_90: "Neste 90 dager",
          later: "Senere",
        },
        empty:
          "Ingen revisits planlagt. Når vi markerer en mulighet som tapt, velger vi når vi skal ta kontakt igjen.",
        load_error: "Kunne ikke hente revisits.",
        due: "Revisit %{date}",
        lost_on: "tapt på %{reason} for %{time} siden",
        contact: "Ta kontakt",
        open_email: "Åpne e-post",
        log_call: "Logg samtale",
        call_content: "Hva ble sagt?",
        call_default: "Revisit-samtale",
        save_call: "Logg samtalen",
        call_logged: "Samtalen er logget",
        start_new: "Start ny mulighet",
        postpone: "Utsett",
        postpone_months: "%{months} mnd",
        postponed: "Revisit flyttet til %{date}",
        close: "Avslutt",
        closed: "Revisit avsluttet for %{name}",
        email_subject: "Fortsatt aktuelt med %{title}?",
        email_body:
          "Hei %{first_name},\n\nFor en stund siden snakket vi om %{title}. Har det blitt mer aktuelt nå?\n\nVennlig hilsen\n%{sender}",
        recurring: {
          label: "Tilbakevendende – tidligere tapt",
          previous: "forrige mulighet",
          follow_ups: "Ny mulighet etter tapet:",
          status: {
            open: "åpen",
            won: "vunnet",
            lost: "tapt",
            disqualified: "diskvalifisert",
          },
        },
      },
    },
    settings: {
      loss_reasons: {
        title: "Tapsårsaker",
        help: "Årsakene vi velger mellom når en mulighet tapes. Standard revisit forhåndsutfyller når vi tar kontakt igjen. En årsak som er brukt, kan skjules, men ikke slettes.",
        label: "Navn",
        revisit_months: "Revisit (mnd)",
        none: "Ingen",
        requires_competitor: "Krever konkurrent",
        requires_comment: "Krever kommentar",
        hidden: "Skjult",
        hidden_badge: "Skjult",
        in_use: "Brukt på %{count} muligheter – kan bare skjules",
        in_use_error: "«%{label}» brukes av muligheter og kan bare skjules.",
        remove: "Slett tapsårsak",
        add: "Legg til tapsårsak",
        save: "Lagre tapsårsakene",
        saved: "Tapsårsakene er lagret",
        save_error: "Tapsårsakene kunne ikke lagres",
        need_label: "Alle tapsårsaker må ha et navn.",
        months_range: "Standard revisit er 1–60 måneder, eller tom for ingen.",
        duplicate: "To tapsårsaker kan ikke ha samme navn.",
      },
      competitors: {
        title: "Konkurrenter",
        help: "Konkurrentene vi taper mot. Nye legges også til fra Tapt-dialogen. En konkurrent som er brukt, kan skjules, men ikke slettes.",
        empty: "Ingen konkurrenter ennå.",
        name: "Navn",
        new: "Ny konkurrent",
        add: "Legg til",
        added: "%{name} er lagt til",
        rename: "Lagre navn",
        saved: "Konkurrenten er lagret",
        save_error: "Konkurrenten kunne ikke lagres",
        duplicate: "Konkurrenten finnes allerede.",
        hide: "Skjul",
        unhide: "Vis",
        delete: "Slett konkurrent",
        deleted: "%{name} er slettet",
        used: "%{smart_count} mulighet |||| %{smart_count} muligheter",
        in_use: "Brukt på muligheter – kan bare skjules",
        in_use_error: "%{name} brukes av muligheter og kan bare skjules.",
      },
    },
    contacts: {
      consent: {
        title: "Samtykke",
        marketing: "Samtykke til markedsføring",
        given: "Samtykke til markedsføring",
        given_at: "Gitt %{date}",
        none: "Ikke samtykke til markedsføring",
        source: "Kilde",
        source_help: "For eksempel «Nettskjema: /kontakt».",
        text: "Samtykketekst",
        text_help: "Den nøyaktige teksten kontakten godtok.",
        opted_out: "Avmeldt",
        opted_out_help:
          "Avmeldingen går foran samtykket. Kontakten får ingen markedsføring.",
      },
    },
  },
};

export const englishPipelineReopenMessages = {
  crm: {
    deals: {
      status: {
        tab_revisit: "Revisit",
      },
      reopen: {
        reason: "Why are we reopening?",
        reasons: {
          closed_too_early: "Closed too early",
          wrong_registration: "Registered by mistake",
          customer_changed_mind: "Customer changed their mind",
        },
        need_reason: "Choose a reason.",
        lost_note:
          "The loss reason and revisit are removed. They stay in the history.",
        won_note:
          "Projects and subscriptions created at the sale are not changed.",
        advice_title: "Reopen or new opportunity?",
        lost_ago: "Lost %{time} ago (%{reason}).",
        lost_ago_no_reason: "Lost %{time} ago.",
        same_need: "Is it the same need and roughly the same scope?",
        yes: "Yes",
        no: "No",
        recommend_new: "We recommend a new opportunity.",
        recommend_reopen: "We recommend reopening («Closed too early»).",
        reopen_anyway: "Reopen anyway",
        new_anyway: "New opportunity anyway",
        new_deal: "New opportunity",
        new_title: "New opportunity from lost",
        new_description:
          "The new opportunity goes to %{stage}, is marked as recurring and is linked to the lost one. The lost one keeps its outcome.",
        create_new: "Create new opportunity",
        new_created: "New opportunity created for %{name}",
        back: "Back",
      },
      revisit: {
        ago: {
          days: "%{smart_count} day |||| %{smart_count} days",
          weeks: "%{smart_count} week |||| %{smart_count} weeks",
          months: "%{smart_count} month |||| %{smart_count} months",
        },
        groups: {
          overdue: "Overdue",
          this_week: "This week",
          next_90: "Next 90 days",
          later: "Later",
        },
        empty:
          "No revisits planned. When we mark an opportunity as lost, we choose when to get in touch again.",
        load_error: "Could not load revisits.",
        due: "Revisit %{date}",
        lost_on: "lost on %{reason} %{time} ago",
        contact: "Get in touch",
        open_email: "Open e-mail",
        log_call: "Log call",
        call_content: "What was said?",
        call_default: "Revisit call",
        save_call: "Log the call",
        call_logged: "The call is logged",
        start_new: "Start new opportunity",
        postpone: "Postpone",
        postpone_months: "%{months} months",
        postponed: "Revisit moved to %{date}",
        close: "Close",
        closed: "Revisit closed for %{name}",
        email_subject: "Still relevant: %{title}?",
        email_body:
          "Hi %{first_name},\n\nA while ago we talked about %{title}. Is it more relevant now?\n\nBest regards\n%{sender}",
        recurring: {
          label: "Recurring – previously lost",
          previous: "previous opportunity",
          follow_ups: "New opportunity after the loss:",
          status: {
            open: "open",
            won: "won",
            lost: "lost",
            disqualified: "disqualified",
          },
        },
      },
    },
    settings: {
      loss_reasons: {
        title: "Loss reasons",
        help: "The reasons we choose between when an opportunity is lost. The default revisit pre-fills when we get in touch again. A reason that has been used can be hidden, but not deleted.",
        label: "Name",
        revisit_months: "Revisit (months)",
        none: "None",
        requires_competitor: "Requires competitor",
        requires_comment: "Requires comment",
        hidden: "Hidden",
        hidden_badge: "Hidden",
        in_use: "Used on %{count} opportunities – can only be hidden",
        in_use_error:
          "«%{label}» is used by opportunities and can only be hidden.",
        remove: "Delete loss reason",
        add: "Add loss reason",
        save: "Save loss reasons",
        saved: "The loss reasons are saved",
        save_error: "The loss reasons could not be saved",
        need_label: "Every loss reason needs a name.",
        months_range: "Default revisit is 1–60 months, or empty for none.",
        duplicate: "Two loss reasons cannot have the same name.",
      },
      competitors: {
        title: "Competitors",
        help: "The competitors we lose to. New ones are also added from the Lost dialog. A competitor that has been used can be hidden, but not deleted.",
        empty: "No competitors yet.",
        name: "Name",
        new: "New competitor",
        add: "Add",
        added: "%{name} is added",
        rename: "Save name",
        saved: "The competitor is saved",
        save_error: "The competitor could not be saved",
        duplicate: "The competitor already exists.",
        hide: "Hide",
        unhide: "Show",
        delete: "Delete competitor",
        deleted: "%{name} is deleted",
        used: "%{smart_count} opportunity |||| %{smart_count} opportunities",
        in_use: "Used on opportunities – can only be hidden",
        in_use_error:
          "%{name} is used by opportunities and can only be hidden.",
      },
    },
    contacts: {
      consent: {
        title: "Consent",
        marketing: "Marketing consent",
        given: "Consented to marketing",
        given_at: "Given %{date}",
        none: "No marketing consent",
        source: "Source",
        source_help: "For example «Web form: /contact».",
        text: "Consent text",
        text_help: "The exact text the contact accepted.",
        opted_out: "Unsubscribed",
        opted_out_help:
          "The unsubscription overrides the consent. The contact gets no marketing.",
      },
    },
  },
};
